import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.data.sources');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-data-sources',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.data.sources/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.source-text {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.source-text-expanded {
  max-height: 30rem;
  overflow-y: auto;
  overscroll-behavior: contain;
}`],
})
export class PageDataSourcesComponent implements OnInit {
    public loading: boolean = true;
    public connecting: boolean = false;
    public importing: boolean = false;
    public sampleLoading: boolean = false;
    public profiling: boolean = false;

    public errorMessage: string = '';
    public noticeMessage: string = '';

    public sources: any[] = [];
    public documents: any[] = [];
    public chunks: any[] = [];
    public summary: any = {};
    public connectionResult: any = null;
    public lastProfile: any = null;
    public sampleMode: 'adapter' | 'stored' = 'stored';
    public selectedSourceId: string = 'nahf-document-archive';
    public expandedTexts: { [key: string]: boolean } = {};

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public async load() {
        this.loading = true;
        this.errorMessage = '';
        await this.service.render();

        try {
            const response = await wiz.call("overview", {
                limit: 20,
                source_id: this.selectedSourceId
            });
            if (response.code !== 200) {
                this.errorMessage = this.responseMessage(
                    response.data,
                    "데이터 소스 정보를 불러오지 못했습니다."
                );
                return;
            }

            this.applyOverview(response.data || {});
            this.sampleMode = 'stored';
        } catch (_error) {
            this.errorMessage = "데이터 소스 정보를 불러오지 못했습니다. 잠시 후 다시 시도해주세요.";
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public async testConnection() {
        if (this.connecting || this.importing) return;

        this.connecting = true;
        this.errorMessage = '';
        this.noticeMessage = '';
        await this.service.render();

        try {
            const response = await wiz.call("test_connection", {
                source_id: this.selectedSourceId
            });
            if (response.code !== 200) {
                this.errorMessage = this.responseMessage(
                    response.data,
                    "데이터 연결을 확인하지 못했습니다."
                );
                return;
            }

            const payload = response.data || {};
            this.connectionResult = payload.connection || payload;
            const samples = this.firstArray([
                payload.sample_chunks,
                payload.chunks,
                payload.records,
                payload.samples,
                this.connectionResult?.sample_chunks,
                this.connectionResult?.chunks,
                this.connectionResult?.records
            ]);

            this.chunks = samples;
            this.sampleMode = 'adapter';
            this.noticeMessage = this.connectionResult?.message
                || (this.isConnected(this.connectionResult)
                    ? "데이터 연결기가 정상적으로 응답했습니다."
                    : "연결 결과를 확인해주세요.");
        } catch (_error) {
            this.errorMessage = "데이터 연결을 확인하지 못했습니다. 잠시 후 다시 시도해주세요.";
        } finally {
            this.connecting = false;
            await this.service.render();
        }
    }

    public async loadSelectedData() {
        if (this.connecting || this.importing) return;

        this.importing = true;
        this.errorMessage = '';
        this.noticeMessage = '';
        await this.service.render();

        try {
            const response = await wiz.call("load_source_data", {
                limit: 20,
                source_id: this.selectedSourceId
            });
            if (response.code !== 200) {
                this.errorMessage = this.responseMessage(
                    response.data,
                    "선택한 데이터를 불러오지 못했습니다."
                );
                return;
            }

            const payload = response.data || {};
            this.applyOverview(payload);
            this.summary = payload.summary || this.summary;
            this.sampleMode = 'stored';

            const result = payload.result || {};
            const documentCount = this.pickNumber(result, [
                "inserted_documents",
                "documents_inserted",
                "document_count"
            ]);
            const chunkCount = this.pickNumber(result, [
                "inserted_chunks",
                "chunks_inserted",
                "chunk_count"
            ]);

            this.noticeMessage = result.message
                || "MySQL 적재를 완료했습니다. 문서 "
                    + this.formatNumber(documentCount)
                    + "건, 문서 조각 "
                    + this.formatNumber(chunkCount)
                    + "건을 반영했습니다.";
        } catch (_error) {
            this.errorMessage = "선택한 데이터를 불러오지 못했습니다. 잠시 후 다시 시도해주세요.";
        } finally {
            this.importing = false;
            await this.service.render();
        }
    }

    public async loadMockData() {
        await this.loadSelectedData();
    }

    public async refreshSamples() {
        if (this.sampleLoading) return;

        this.sampleLoading = true;
        this.errorMessage = '';
        await this.service.render();

        try {
            const response = await wiz.call("sample_records", {
                limit: 20,
                source_id: this.selectedSourceId
            });
            if (response.code !== 200) {
                this.errorMessage = this.responseMessage(
                    response.data,
                    "문서 조각 샘플을 불러오지 못했습니다."
                );
                return;
            }

            this.chunks = this.firstArray([
                response.data?.chunks,
                response.data?.records,
                response.data
            ]);
            this.sampleMode = 'stored';
            this.noticeMessage = this.chunks.length > 0
                ? "MySQL에 저장된 문서 조각 샘플을 불러왔습니다."
                : "저장된 문서 조각이 없습니다. 선택한 데이터를 먼저 불러와주세요.";
        } catch (_error) {
            this.errorMessage = "문서 조각 샘플을 불러오지 못했습니다. 잠시 후 다시 시도해주세요.";
        } finally {
            this.sampleLoading = false;
            await this.service.render();
        }
    }

    public async runProfile() {
        if (this.profiling || this.importing || this.connecting) return;

        this.profiling = true;
        this.errorMessage = '';
        this.noticeMessage = '';
        await this.service.render();

        try {
            const response = await wiz.call("profile_data", {
                source_id: this.selectedSourceId
            });
            if (response.code !== 200) {
                this.errorMessage = this.responseMessage(
                    response.data,
                    "데이터 구조를 분석하지 못했습니다."
                );
                return;
            }

            this.lastProfile = response.data || {};
            const documents = this.profileCount(this.lastProfile, [
                "total_documents",
                "documents",
                "document_count"
            ]);
            const chunks = this.profileCount(this.lastProfile, [
                "total_chunks",
                "chunks",
                "chunk_count",
                "total_records"
            ]);
            this.noticeMessage = "데이터 구조 분석을 저장했습니다. 도서 "
                + this.formatNumber(documents)
                + "건, 문서 조각 "
                + this.formatNumber(chunks)
                + "건을 분석했습니다.";

            await this.loadSourceSummary();
        } catch (_error) {
            this.errorMessage = "데이터 구조를 분석하지 못했습니다. 잠시 후 다시 시도해주세요.";
        } finally {
            this.profiling = false;
            await this.service.render();
        }
    }

    public get sourceCount(): number {
        return this.summaryCount(
            ["data_sources", "data_source_count", "source_count", "sources"],
            this.sources.length
        );
    }

    public get documentCount(): number {
        return this.summaryCount(
            ["documents", "document_count", "source_documents"],
            this.documents.length
        );
    }

    public get chunkCount(): number {
        return this.summaryCount(
            ["chunks", "chunk_count", "source_chunks", "records"],
            this.chunks.length
        );
    }

    public get connectionStatusLabel(): string {
        const result = this.connectionResult || this.selectedSource;
        if (!result) return "테스트 전";
        return this.isConnected(result) ? "연결 가능" : "연결 확인 필요";
    }

    public get connectionStatusClass(): string {
        const result = this.connectionResult || this.selectedSource;
        if (!result) return "bg-slate-100 text-slate-600";
        return this.isConnected(result)
            ? "bg-emerald-50 text-emerald-700 ring-emerald-600/20"
            : "bg-amber-50 text-amber-800 ring-amber-600/20";
    }

    public adapterName(): string {
        return this.connectionResult?.adapter_type
            || this.connectionResult?.adapter
            || this.selectedSource?.adapter_type
            || "데이터 연결기";
    }

    public get selectedSource(): any {
        return this.sources.find(source => source?.id === this.selectedSourceId) || null;
    }

    public get isArchiveSource(): boolean {
        return this.selectedSourceId === 'nahf-document-archive';
    }

    public sourceInitials(): string {
        return this.isArchiveSource ? 'API' : 'MV';
    }

    public sourceDescription(): string {
        if (this.isArchiveSource) {
            return '연동된 실제 자료함에서 XML 자료 메타데이터와 검색 발췌를 읽고, 선택 문서는 원문 XML로 보완할 수 있습니다.';
        }
        return '외부 연결 없이 직접 작성한 역사 문서 회귀시험 데이터를 제공합니다.';
    }

    public importButtonLabel(): string {
        return this.isArchiveSource
            ? '실제 자료 검증 데이터 불러오기'
            : '시험용 가짜 데이터 불러오기';
    }

    public connectionTarget(): string {
        return this.isArchiveSource ? '동북아역사 자료함 API' : '시스템 내장 시험 데이터';
    }

    public securityLabel(): string {
        return this.isArchiveSource ? '서버에서 접속 키 보호' : '접속 키 불필요';
    }

    public async selectSource(source: any) {
        const sourceId = String(source?.id || '').trim();
        if (!sourceId || sourceId === this.selectedSourceId) return;
        this.selectedSourceId = sourceId;
        this.connectionResult = null;
        this.lastProfile = null;
        this.noticeMessage = '';
        this.errorMessage = '';
        this.expandedTexts = {};
        await this.load();
    }

    public sourceName(source: any): string {
        return source?.name || source?.title || "시험용 역사 데이터";
    }

    public sourceType(source: any): string {
        return source?.source_type || source?.type || "vector";
    }

    public sourceStatus(source: any): string {
        const status = String(source?.connection_status || source?.status || "ready").toLowerCase();
        if (["connected", "ready", "success", "ok", "loaded"].includes(status)) return "연결됨";
        if (["failed", "error", "disconnected"].includes(status)) return "연결 오류";
        return "대기";
    }

    public sourceStatusClass(source: any): string {
        const label = this.sourceStatus(source);
        if (label === "연결됨") return "bg-emerald-50 text-emerald-700";
        if (label === "연결 오류") return "bg-red-50 text-red-700";
        return "bg-slate-100 text-slate-600";
    }

    public documentTitle(document: any): string {
        return document?.title || document?.document_title || "제목 없음";
    }

    public documentExternalId(document: any): string {
        return document?.external_id || document?.document_id || document?.id || "-";
    }

    public documentAuthor(document: any): string {
        return document?.author || document?.metadata?.author || "-";
    }

    public documentYear(document: any): string {
        return document?.publication_year || document?.year || "-";
    }

    public chunkDocumentTitle(chunk: any): string {
        return chunk?.document_title
            || chunk?.title
            || chunk?.document?.title
            || chunk?.metadata?.document_title
            || "-";
    }

    public chunkExternalId(chunk: any): string {
        return chunk?.external_id || chunk?.chunk_id || chunk?.id || "-";
    }

    public chunkPage(chunk: any): string {
        const value = chunk?.page ?? chunk?.page_number ?? chunk?.metadata?.page;
        return value === undefined || value === null || value === "" ? "-" : String(value);
    }

    public chunkIndex(chunk: any): string {
        const value = chunk?.chunk_index ?? chunk?.index ?? chunk?.order;
        return value === undefined || value === null || value === "" ? "-" : String(value);
    }

    public chunkText(chunk: any): string {
        return this.chunkFullText(chunk);
    }

    public chunkFullText(chunk: any): string {
        if (typeof chunk === 'string') return chunk;
        return String(
            chunk?.full_text
            || chunk?.text
            || chunk?.content
            || chunk?.original_text
            || "원문 없음"
        );
    }

    public chunkPreview(chunk: any): string {
        const provided = chunk?.text_preview;
        if (provided !== undefined && provided !== null && String(provided).trim()) {
            return String(provided);
        }
        return this.createPreview(this.chunkFullText(chunk));
    }

    public displayedChunkText(chunk: any, index: number): string {
        return this.isTextExpanded(chunk, index)
            ? this.chunkFullText(chunk)
            : this.chunkPreview(chunk);
    }

    public async toggleChunkText(chunk: any, index: number) {
        const key = this.chunkTextKey(chunk, index);
        this.expandedTexts[key] = !this.expandedTexts[key];
        await this.service.render();
    }

    public isTextExpanded(chunk: any, index: number): boolean {
        return this.expandedTexts[this.chunkTextKey(chunk, index)] === true;
    }

    public chunkToggleLabel(chunk: any, index: number): string {
        if (this.isTextExpanded(chunk, index)) return "접기";
        return this.isSearchExcerpt(chunk) ? "발췌문 펼치기" : "전체 보기";
    }

    public chunkContentLabel(chunk: any): string {
        if (this.isSearchExcerpt(chunk)) return "검색 발췌문";
        if (this.isCompleteText(chunk)) return "전체 원문 기반 조각";
        return "불완전 원문";
    }

    public chunkBoundaryLabel(chunk: any): string {
        if (this.chunkForcedSplit(chunk)) return "강제 분할됨";
        if (this.isSearchExcerpt(chunk)) return "문장 경계 미검증";
        return "문장 경계에서 정상 분할";
    }

    public chunkContentClass(chunk: any): string {
        if (this.isSearchExcerpt(chunk)) return "bg-amber-50 text-amber-800 ring-amber-600/20";
        if (this.isCompleteText(chunk)) return "bg-emerald-50 text-emerald-700 ring-emerald-600/20";
        return "bg-slate-100 text-slate-700 ring-slate-500/20";
    }

    public chunkBoundaryClass(chunk: any): string {
        return this.chunkForcedSplit(chunk)
            ? "bg-red-50 text-red-700 ring-red-600/20"
            : "bg-sky-50 text-sky-700 ring-sky-600/20";
    }

    public isSearchExcerpt(chunk: any): boolean {
        const type = String(
            chunk?.content_type
            || chunk?.metadata?.content_type
            || ""
        ).toLowerCase();
        const scope = String(chunk?.metadata?.ingestion_scope || "").toLowerCase();
        const kind = String(chunk?.metadata?.record_kind || "").toLowerCase();
        return type === "search_excerpt"
            || scope === "validation_excerpt"
            || kind === "source_chunk_excerpt";
    }

    public isCompleteText(chunk: any): boolean {
        const explicit = chunk?.is_complete_text ?? chunk?.metadata?.is_complete_text;
        if (explicit !== undefined && explicit !== null) return explicit === true;
        return !this.isSearchExcerpt(chunk) && !this.isSourceTruncated(chunk);
    }

    public isSourceTruncated(chunk: any): boolean {
        const explicit = chunk?.is_source_truncated ?? chunk?.metadata?.is_source_truncated;
        if (explicit !== undefined && explicit !== null) return explicit === true;
        return this.isSearchExcerpt(chunk) || chunk?.metadata?.excerpt_truncated === true;
    }

    public chunkLimitationReason(chunk: any): string {
        if (!this.isSearchExcerpt(chunk)) return "";
        return chunk?.limitation_reason
            || chunk?.metadata?.limitation_reason
            || "외부 API가 전체 원문이 아닌 제한된 검색 발췌문만 제공함";
    }

    public chunkForcedSplit(chunk: any): boolean {
        return (chunk?.forced_split ?? chunk?.metadata?.forced_split) === true;
    }

    public chunkExtractionUsable(chunk: any): boolean {
        const explicit = chunk?.knowledge_extraction_usable
            ?? chunk?.knowledge_extraction_eligible
            ?? chunk?.extraction_eligible
            ?? chunk?.metadata?.knowledge_extraction_usable
            ?? chunk?.metadata?.knowledge_extraction_eligible
            ?? chunk?.metadata?.extraction_eligible;
        if (explicit !== undefined && explicit !== null) return explicit === true;
        return this.isCompleteText(chunk) && !this.isSearchExcerpt(chunk);
    }

    public vectorReference(chunk: any): string {
        return chunk?.vector_reference
            || chunk?.vector_record_id
            || chunk?.record_id
            || chunk?.metadata?.vector_reference
            || "-";
    }

    public formatNumber(value: number): string {
        return Number(value || 0).toLocaleString('ko-KR');
    }

    public profileCreatedAt(): string {
        const value = this.lastProfile?.created_at;
        if (!value) return "";
        const date = new Date(value);
        return Number.isNaN(date.getTime()) ? String(value) : date.toLocaleString('ko-KR');
    }

    private applyOverview(payload: any) {
        this.sources = this.firstArray([
            payload?.sources,
            payload?.data_sources
        ]);
        this.documents = this.firstArray([
            payload?.documents,
            payload?.source_documents
        ]);
        this.chunks = this.firstArray([
            payload?.chunks,
            payload?.source_chunks,
            payload?.records
        ]);
        this.summary = payload?.summary || payload?.counts || this.summary || {};
        if (this.sources.length > 0 && !this.selectedSource) {
            this.selectedSourceId = this.sources[0]?.id || 'mock-history';
        }
        if (!this.connectionResult && this.selectedSource) {
            this.connectionResult = this.selectedSource;
        }
    }

    private async loadSourceSummary() {
        const response = await wiz.call("overview", {
            limit: 20,
            source_id: this.selectedSourceId
        });
        if (response.code === 200) this.applyOverview(response.data || {});
    }

    private profileCount(profile: any, keys: string[]): number {
        const scopes = [profile, profile?.summary, profile?.statistics];
        for (const scope of scopes) {
            if (!scope || Array.isArray(scope)) continue;
            for (const key of keys) {
                if (scope[key] !== undefined && scope[key] !== null) {
                    return this.toCount(scope[key]);
                }
            }
        }
        return 0;
    }

    private isConnected(result: any): boolean {
        if (result?.connected === true || result?.success === true) return true;
        const status = String(result?.status || result?.connection_status || "").toLowerCase();
        return ["connected", "ready", "success", "ok"].includes(status);
    }

    private summaryCount(keys: string[], fallback: number): number {
        const scopes = [
            this.summary,
            this.summary?.summary,
            this.summary?.counts,
            this.summary?.stats
        ];

        for (const scope of scopes) {
            if (!scope || Array.isArray(scope)) continue;
            for (const key of keys) {
                if (scope[key] !== undefined && scope[key] !== null) {
                    return this.toCount(scope[key]);
                }
            }
        }

        return fallback;
    }

    private pickNumber(value: any, keys: string[]): number {
        for (const key of keys) {
            if (value?.[key] !== undefined && value?.[key] !== null) {
                return this.toCount(value[key]);
            }
        }
        return 0;
    }

    private toCount(value: any): number {
        if (Array.isArray(value)) return value.length;
        if (value && typeof value === 'object') {
            if (Array.isArray(value.items)) return value.items.length;
            if (value.count !== undefined) return this.toCount(value.count);
            if (value.total !== undefined) return this.toCount(value.total);
        }

        const numberValue = Number(value || 0);
        return Number.isFinite(numberValue) ? numberValue : 0;
    }

    private firstArray(candidates: any[]): any[] {
        for (const candidate of candidates) {
            if (Array.isArray(candidate)) return candidate;
            if (Array.isArray(candidate?.items)) return candidate.items;
            if (Array.isArray(candidate?.rows)) return candidate.rows;
            if (Array.isArray(candidate?.data)) return candidate.data;
        }
        return [];
    }

    private chunkTextKey(chunk: any, index: number): string {
        const id = chunk?.id || chunk?.chunk_id || chunk?.external_id || index;
        return this.selectedSourceId + ":sample:" + String(id);
    }

    private createPreview(value: string, maximum: number = 240): string {
        const text = String(value || "");
        if (text.length <= maximum) return text;

        const candidate = text.slice(0, maximum);
        const boundaries = [
            candidate.lastIndexOf("\n"),
            candidate.lastIndexOf("다. "),
            candidate.lastIndexOf(". "),
            candidate.lastIndexOf("。"),
            candidate.lastIndexOf("! "),
            candidate.lastIndexOf("? ")
        ];
        const boundary = Math.max(...boundaries);
        const end = boundary >= Math.floor(maximum * 0.55) ? boundary + 1 : maximum;
        return candidate.slice(0, end).trimEnd() + "…";
    }

    private responseMessage(data: any, fallback: string): string {
        return typeof data === 'string' ? data : data?.message || fallback;
    }
}

export default PageDataSourcesComponent;